export const FontSizeClasses = {
    FONT_SIZE_XXS: ['wf-text-xxs'],
    FONT_SIZE_XS: ['wf-text-xs'],
    FONT_SIZE_SM: ['wf-text-sm'],
    FONT_SIZE_BASE: ['wf-text-base'],
    FONT_SIZE_XL: ['wf-text-xl'],
    FONT_SIZE_3XL: ['wf-text-3xl'],
    FONT_SIZE_5XL: ['wf-text-5xl'],
    FONT_SIZE_6XL: ['wf-text-6xl'],
}